module.exports = __webpack_public_path__ + "assets/img/logo-rakumart-europe.fb08a881.svg";